import { TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

import ImageUpload from '../../ImageUpload/ImageUpload';

export function BrandForm({
  errors,
  brand,
  Controller,
  control,
  addImage,
  setAddImage,
}) {
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={brand ? brand.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อแบรนด์"
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
              required
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'description'}
          control={control}
          defaultValue={brand ? brand.description : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              size={'small'}
              helperText={errors.description && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>

      {/* <div className="w-full px-1 py-2">
        <Controller
          name={'url'}
          control={control}
          defaultValue={brand ? brand.url : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ลิงค์แบรนด์"
              fullWidth
              size={'small'}
              helperText={errors.description && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div> */}

      {/* <div className="w-full pl-2">
        <Controller
          name={'show_front'}
          control={control}
          defaultValue={brand ? brand.show_front : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="แสดงแบรนด์หน้าเว็ปไซต์"
            />
          )}
        />
      </div> */}

      <div className="w-full px-1 py-2">
        <ImageUpload
          preview_size="250"
          profile={1}
          maxNumber={1}
          images={addImage}
          setImages={setAddImage}
          title={brand?.image ? 'แก้ไขรูปภาพ/โลโก้' : 'อัพโหลดรูปภาพ/โลโก้'}
        />
      </div>
    </div>
  );
}

BrandForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    description: PropTypes.object,
  }),
  addImage: PropTypes.arrayOf(PropTypes.object),
  setAddImage: PropTypes.func.isRequired,
  brand: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
  showFront: PropTypes.bool,
  setShowFront: PropTypes.func,
};

BrandForm.defaultProps = {
  brand: null,
};

export default BrandForm;
